import slideToggle from "../../../js/modules/slideToggle.js";

// Функция для обработки мобильных кнопок
const mobileButtons = () => {
    // Обработчик для кнопок с открытием меню
    document.querySelectorAll('.header__mobile-button').forEach(btn => {
        btn.addEventListener('click', (event) => {
            // Если кнопка раскрывает какое-либо меню
            if (btn.dataset.buttonName) {
                event.preventDefault();

                // Переключаем активное состояние кнопки
                btn.classList.toggle('header__mobile-button_active');

                // Находим контейнер с соответствующим data-button-name и переключаем его видимость
                document.querySelectorAll('.header__mobile-button-container').forEach(container => {
                    if (btn.dataset.buttonName === container.dataset.buttonName) {
                        container.slideToggle(200);
                    }
                });
            }
        });
    });

    // Фокус на поле поиска
    const searchBtn = document.querySelector('.header__mobile-button[data-button-name="search"]');
    if (searchBtn) {
        searchBtn.addEventListener('click', () => {
            const searchInput = document.querySelector('.header__mobile-button-container[data-button-name="search"] input[type="search"]');
            if (searchBtn.classList.contains('header__mobile-button_active')) {
                searchInput?.focus();
            } else {
                searchInput?.blur();
            }
        });
    }
}

export default mobileButtons;